import type { RoleColumns, RolesRequest } from '@library/types/role';
import type { TableColumn } from '@library/types/utils';
import type { UserRoleOption } from '@library/types/user';
import { v4 as uuid } from 'uuid';

export const ROLES_HEADER: Array<TableColumn<RoleColumns>> = [
  {
    column: 'role_name',
    essential: true,
    label: 'Role',
    sortEnabled: false,
    width: 'w-1/3'
  },
  {
    column: 'permissions_count',
    essential: true,
    label: 'Permissions',
    sortEnabled: false,
    width: 'w-1/6'
  },
  {
    column: 'description',
    essential: true,
    label: 'Description',
    sortEnabled: false,
    width: 'w-1/2'
  }
];

export const DEFAULT_ROLES_REQUEST: RolesRequest = {
  page: 1,
  perPage: 25
};

export const DEFAULT_TRANSACTION_MAX_IDS = [
  '36', // approve_and_deny_withdrawals
  '37', // add_free_entry
  '38', // create_adjustment
  '39' // refund_entry
];

export const DEFAULT_ROLE_OPTION: UserRoleOption = {
  id: uuid(),
  isSettingOpen: true,
  role: null,
  leagues: [],
  transactionMaxes: []
};
